import React from 'react';

interface AboutProps {
  event: any;
}

const About: React.FC<AboutProps> = ({ event }) => {
  if (!event?.content?.description) {
    return null;
  }

  return (
    <div className="about-section">
      <h2 className="section-title">
        <i className="fas fa-info-circle me-2"></i>
        About The Event
      </h2>
      <div className="description-content">
        <div 
          className="event-description"
          dangerouslySetInnerHTML={{ __html: event.content.description }}
        />
      </div>
    </div>
  );
};

export default About;
